export const getAdPreviewPlaceholderStyles = (_, { palette = {} }) => ({
  adPreviewPlaceholderContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: 1211,
    justifyContent: 'space-between',
  },
  'adPreviewPlaceholderContainer-s': {
    width: 360,
    '& .ad-preview-placeholder-column1': {
      display: 'none',
    },
    '& .ad-preview-placeholder-column2': {
      width: 360,
    },
    '& .ad-preview-placeholder-column3': {
      display: 'none',
    },
  },
  placementContainer: {
    width: 'auto',
    margin: '10px 0',
    transition: 'transform .2s',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  adPreviewPlaceholderColumn1: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'start',
    width: 339,
    paddingTop: 100,
  },
  adPreviewPlaceholderColumn2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 439,
  },
  adPreviewPlaceholderColumn3: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'start',
    width: 361,
    paddingTop: 80,
  },
  tooltip: {
    backgroundColor: `${palette.black} !important`,
    color: '#ffffff !important',
    fontSize: '12px !important',
    maxWidth: 'unset !important',
    padding: '9px 16px !important',
    top: '100px !important',
  },
});
